import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GateKeepingWidgetsModule } from './widgets/gate-keeping-widgets.module';



@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    GateKeepingWidgetsModule,
  ]
})
export class GateKeepingModule { }
